import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import style from './style.module.scss';
import {selectCartNewAdded} from 'modules/cart/selectors';
import React, {useCallback, useEffect, useMemo} from 'react';
import {Typography} from 'components/Typography';
import classNames from 'classnames';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {actionSetAddedProduct} from 'modules/cart/slice';
import {CartMiniProductItem} from '../CartMiniProductItem/CartMiniProductItem';
import {ICartProduct} from 'modules/cart/models';
import Icon from 'components/Icon';
import {CART_ROUTE_TO_URL} from 'core/modules/routing/constants';
import {PriceProgressBar} from 'modules/cart/components/PriceProgressBar';
import {useGetCartQuery} from 'modules/cart/services';
import CartBanner from 'modules/cart/components/CartBanner/CartBanner';
import {useGrowingDiscountGtag} from 'modules/product-card/analytics/gtag/hooks/useGrowingDiscountGtag';
import {ButtonNew} from 'components/ButtonNew';

export const CartAddNotification = () => {
    const dispatch = useAppDispatch();

    const newProduct = useAppSelector(selectCartNewAdded);
    const {data: cartData} = useGetCartQuery({mini: true});

    // показываем уведомление если есть новый добавленный товар и только если данные корзины уже загружены
    const cartDataLoaded = cartData !== undefined;
    const shouldShowNotification =
        Boolean(newProduct) &&
        (!cartDataLoaded || cartData.products.some((product) => product.offerId === newProduct?.offerId));

    const clearNewProduct = useCallback(() => {
        dispatch(actionSetAddedProduct(null));
    }, [dispatch]);

    const {handleAddToCartWidgetInView} = useGrowingDiscountGtag();

    const banner = useMemo(() => {
        return cartData?.banners;
    }, [cartData]);

    const isGrowingDiscountBanner = useMemo(
        () => banner && 0 <= (newProduct?.labels ?? []).findIndex((label) => 'GROWING_DISCOUNT' === label.code),
        [newProduct?.labels, banner],
    );

    useEffect(() => {
        if (!shouldShowNotification) {
            return;
        }
        const timer = setTimeout(() => {
            clearNewProduct();
        }, 4000);

        if (isGrowingDiscountBanner) {
            handleAddToCartWidgetInView();
        }

        // eslint-disable-next-line consistent-return
        return () => {
            clearTimeout(timer);
        };
    }, [clearNewProduct, handleAddToCartWidgetInView, isGrowingDiscountBanner, shouldShowNotification]);

    return (
        <div
            className={classNames(style.container, {
                [style.hidden]: !shouldShowNotification,
            })}
        >
            <div className={style.header}>
                <Typography variant={'h3'}>Товар добавлен в корзину</Typography>
                <div
                    className={style.closeButton}
                    onClick={() => {
                        clearNewProduct();
                    }}
                >
                    <Icon icon={'close'} />
                </div>
            </div>

            <PriceProgressBar percent={cartData?.minimalCartPrice?.percent} left={cartData?.minimalCartPrice?.left} />

            {banner && <CartBanner isMiniCart={false} />}

            <div className={style.body}>
                {shouldShowNotification && newProduct && (
                    <CartMiniProductItem
                        className={style.item}
                        {...(newProduct as ICartProduct)}
                        isCounter={false}
                        isDeleteButton={false}
                    />
                )}
                <ButtonNew isStretched={true} variant={'medium'} href={CART_ROUTE_TO_URL}>
                    Перейти в корзину
                </ButtonNew>
            </div>
        </div>
    );
};
